import { 
  useDispatch as useReduxDispatch,
  useSelector as useReduxSelector
} from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';
import type { ThunkAction } from 'redux-thunk';
import { configureStore } from '@reduxjs/toolkit';
import type { Action } from  '@reduxjs/toolkit';
import { ENABLE_REDUX_DEV_TOOLS } from 'src/constants';
import rootReducer from './rootReducer';
import { itemTrackerAPI } from 'src/apis/itemTrackerAPI';
import { setupListeners } from '@reduxjs/toolkit/query';
import { alertReportsAPI } from 'src/apis/alertReportsAPI';
import { apiKeysAPI } from 'src/apis/apiKeysAPI';
import { transactionsAPI } from 'src/apis/transactionsAPI';
import { intelligencePointAPI } from 'src/apis/intelligencePointAPI';
import { dashboardAPI } from 'src/apis/dashboardAPI';
import { productAPI } from 'src/features/product/api/productApi';
import { storeAPI } from 'src/features/store/api/storeApi';
import { inventorySessionAPI } from 'src/apis/inventorySessionAPI';
import { productImportsAPI } from 'src/apis/productImportsAPI';
const store = configureStore({
  reducer: rootReducer,
  devTools: ENABLE_REDUX_DEV_TOOLS,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(itemTrackerAPI.middleware)
      .concat(alertReportsAPI.middleware)
      .concat(transactionsAPI.middleware)
      .concat(apiKeysAPI.middleware)
      .concat(intelligencePointAPI.middleware)
      .concat(dashboardAPI.middleware)
      .concat(productAPI.middleware)
      .concat(storeAPI.middleware)
      .concat(inventorySessionAPI.middleware)
      .concat(productImportsAPI.middleware)

});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export type AppThunk = ThunkAction<void, RootState, null, Action<string>>;

export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;

export const useDispatch = () => useReduxDispatch<AppDispatch>();
setupListeners(store.dispatch)
export default store;
